// extracted by mini-css-extract-plugin
export var actionButton = "_af-1";
export var actionButtons = "_af-2";
export var actions = "_af-0";
export var aiUnread = "_af-10";
export var alignCenter = "_af-h";
export var backWrapper = "_af-3";
export var cellContainer = "_af-4";
export var checkboxContainer = "_af-5";
export var contentContainer = "_af-6";
export var contentHeader = "_af-8";
export var conversationsTableWrapper = "_af-s";
export var draftReplyBadgeContainer = "_af-m";
export var dropdownItem = "_af-b";
export var dropdownItemsContainer = "_af-a";
export var dropdownTitle = "_af-c";
export var errorIcon = "_af-7";
export var filter = "_af-d";
export var gray = "_af-i";
export var headerActionButtons = "_af-e";
export var headerCheckboxContainer = "_af-f";
export var icon = "_af-j";
export var menuContainer = "_af-k";
export var noMoreTicketsIcon = "_af-12";
export var noMoreTicketsSubText = "_af-13";
export var oneLine = "_af-l";
export var optionsButton = "_af-n";
export var plus = "_af-o";
export var portalButtonsWrapper = "_af-g";
export var red = "_af-p";
export var scrolledTop = "_af-9";
export var search = "_af-q";
export var selectedConversationsCount = "_af-r";
export var spinner = "_af-t";
export var strong = "_af-u";
export var summaryCell = "_af-v";
export var tableContainer = "_af-11";
export var tagContainer = "_af-w";
export var threeDots = "_af-x";
export var twoLines = "_af-y";
export var unread = "_af-z";